var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/health-metrics/v1/constants/metric-types.constants.ts
var supportedMetrics = [
  "distance",
  "steps",
  "active_duration",
  // , 'sleep_duration'
  "mindful_duration",
  "floors_climbed",
  // , 'idle_hours_count'
  "energy_burned"
  // , 'calcium'
  // , 'min_heart_rate'
  // , 'max_heart_rate'
  // , 'workout_duration'
  // , 'stand_hours_count'
  // , 'cholesterol'
  // , 'carbohydrate'
  // , 'dietary_fiber'
  // , 'avg_heart_rate'
  // , 'energy_consumed'
  // , 'awake_duration'
  // , 'blood_glucose'
  // , 'bmi'
  // , 'body_fat'
  // , 'body_height'
  // , 'body_temperature'
  // , 'body_weight';
  // , 'diastolic'
  // , 'fat'
  // , 'in_bed_duration'
  // , 'insulin'
  // , 'protein'
  // , 'pulse'
  // , 'saturated_fat'
  // , 'sodium'
  // , 'spo2'
  // , 'systolic'
  // , 'water'
  // , 'sugars'
  // , 'unsaturated_fat';
];

// src/dashboard-config/constants.ts
var DASHBOARD_CONFIG_PATH = "v1/health-dashboard-configs";

// src/health-metrics/v1/get-health-metrics.ts
import { query, deserialise } from "kitsu-core";
import { leagueFetch } from "@leagueplatform/league-fetch";
var healthMetricsV1Path = "v1/health-metrics";
function getHealthMetrics(params) {
  return __async(this, null, function* () {
    const response = yield leagueFetch(`${healthMetricsV1Path}?${query(params)}`);
    const responseJson = yield response.json();
    if (!response.ok) {
      throw new Error(`getHealthMetrics error: ${response.status}`);
    }
    return deserialise(responseJson);
  });
}

// src/health-metrics/v3/get-health-metrics.ts
import { query as query2, deserialise as deserialise2 } from "kitsu-core";
import { leagueFetch as leagueFetch2 } from "@leagueplatform/league-fetch";
var healthMetricsV3Path = "v3/health-metrics";
function getHealthMetrics2(params) {
  return __async(this, null, function* () {
    const response = yield leagueFetch2(`${healthMetricsV3Path}?${query2(params)}`);
    const responseJson = yield response.json();
    if (!response.ok) {
      throw new Error(`getHealthMetrics error: ${response.status}`);
    }
    const deseralizedData = deserialise2(
      responseJson
    );
    return deseralizedData;
  });
}
function getHealthMetricsByPaginationLink(page) {
  return __async(this, null, function* () {
    const response = yield leagueFetch2(page);
    const responseJson = yield response.json();
    if (!response.ok) {
      throw new Error(`getHealthMetrics error: ${response.status}`);
    }
    const deseralizedData = deserialise2(
      responseJson
    );
    return deseralizedData;
  });
}

// src/constants/health-metrics.constants.ts
var InputType = /* @__PURE__ */ ((InputType2) => {
  InputType2["QUANTITY"] = "quantity";
  InputType2["ENUM"] = "enum";
  InputType2["PERIOD"] = "period";
  return InputType2;
})(InputType || {});
var FieldType = /* @__PURE__ */ ((FieldType2) => {
  FieldType2["QUANTITY"] = "quantity";
  FieldType2["DATETIME"] = "date-time";
  return FieldType2;
})(FieldType || {});

// src/health-metrics/v2/types/health-metrics-data.type.ts
var HEALTH_METRIC = "health-metric";

// src/health-metrics/v2/get-health-metrics.ts
import { query as query3, deserialise as deserialise3 } from "kitsu-core";
import { leagueFetch as leagueFetch3 } from "@leagueplatform/league-fetch";
var healthMetricsV2Path = "v2/health-metrics";
function getHealthMetrics3(params) {
  return __async(this, null, function* () {
    const response = yield leagueFetch3(`${healthMetricsV2Path}?${query3(params)}`);
    const responseJson = yield response.json();
    if (!response.ok) {
      throw new Error(`getHealthMetrics error: ${response.status}`);
    }
    const deseralizedData = deserialise3(
      responseJson
    );
    return deseralizedData;
  });
}
function getHealthMetricsByPaginationLink2(page) {
  return __async(this, null, function* () {
    const response = yield leagueFetch3(page);
    const responseJson = yield response.json();
    if (!response.ok) {
      throw new Error(`getHealthMetrics error: ${response.status}`);
    }
    const deseralizedData = deserialise3(
      responseJson
    );
    return deseralizedData;
  });
}

// src/health-sources/get-health-sources.ts
import { query as query4, deserialise as deserialise4 } from "kitsu-core";
import { leagueFetch as leagueFetch4 } from "@leagueplatform/league-fetch";
var healthSourcesV1Path = "v1/health-sources";
function getHealthSources(params) {
  return __async(this, null, function* () {
    const response = yield leagueFetch4(`${healthSourcesV1Path}?${query4(params)}`);
    const responseJson = yield response.json();
    if (!response.ok) {
      throw new Error(`getHealthSources error: ${response.status}`);
    }
    return deserialise4(responseJson);
  });
}

// src/health-literacy/get-health-literacy.ts
import { deserialise as deserialise5 } from "kitsu-core";
import { leagueFetch as leagueFetch5 } from "@leagueplatform/league-fetch";
var HEALTH_LITERACY_PATH = "v1/health-literacy";
function getHealthLiteracy(dataType) {
  return __async(this, null, function* () {
    const response = yield leagueFetch5(`${HEALTH_LITERACY_PATH}/${dataType}`);
    const responseJson = yield response.json();
    if (!response.ok) {
      throw new Error(`getHealthLiteracy error: ${response.status}`);
    }
    return deserialise5(responseJson);
  });
}

// src/dashboard-config/get-dashboard-config.ts
import { deserialise as deserialise6 } from "kitsu-core";
import { leagueFetch as leagueFetch6 } from "@leagueplatform/league-fetch";
function getDashboardConfig() {
  return __async(this, null, function* () {
    const response = yield leagueFetch6(`${DASHBOARD_CONFIG_PATH}`);
    const responseJson = yield response.json();
    if (!response.ok) {
      throw new Error(`getDashboardConfig error: ${response.status}`);
    }
    return deserialise6(responseJson);
  });
}

// src/dashboard-config/patch-dashboard-config.ts
import { leagueFetch as leagueFetch7 } from "@leagueplatform/league-fetch";
import { deserialise as deserialise7 } from "kitsu-core";
function patchDashboardConfig(units, dashboardConfig) {
  return __async(this, null, function* () {
    const response = yield leagueFetch7(DASHBOARD_CONFIG_PATH, {
      method: "PATCH",
      body: JSON.stringify({
        data: {
          id: dashboardConfig.data.id,
          type: dashboardConfig.data.type,
          attributes: {
            units
          }
        }
      })
    });
    if (response.status !== 200) {
      throw new Error(`patchDashboardConfig error: ${response.status}`);
    }
    const responseJson = yield response.json();
    return deserialise7(responseJson.data);
  });
}

// src/health-metrics/v3/patch-health-metrics.ts
import { leagueFetch as leagueFetch8 } from "@leagueplatform/league-fetch";
import { deserialise as deserialise8 } from "kitsu-core";

// src/health-metrics/v3/types/health-metrics-data.type.ts
var HEALTH_METRIC2 = "health-metric";

// src/health-metrics/v3/patch-health-metrics.ts
function updateHealthMetrics(_0) {
  return __async(this, arguments, function* ({
    data,
    observationId
  }) {
    const response = yield leagueFetch8(`v3/health-metrics/${observationId}`, {
      method: "PATCH",
      body: JSON.stringify({
        data: {
          id: observationId,
          type: HEALTH_METRIC2,
          attributes: data
        }
      })
    });
    if (!response.ok) {
      throw new Error(`PostCreateHealthMetrics error: ${response.status}`);
    }
    const responseJson = yield response.json();
    return deserialise8(responseJson);
  });
}

// src/health-metrics/v3/post-health-metrics.ts
import { leagueFetch as leagueFetch9 } from "@leagueplatform/league-fetch";
import { deserialise as deserialise9 } from "kitsu-core";
function createHealthMetrics(data) {
  return __async(this, null, function* () {
    const response = yield leagueFetch9("v3/health-metrics", {
      method: "POST",
      body: JSON.stringify({
        data: {
          type: HEALTH_METRIC2,
          attributes: data
        }
      })
    });
    if (!response.ok) {
      throw new Error(`PostCreateHealthMetrics error: ${response.status}`);
    }
    const responseJson = yield response.json();
    return deserialise9(responseJson);
  });
}
export {
  DASHBOARD_CONFIG_PATH,
  FieldType,
  HEALTH_METRIC,
  InputType,
  createHealthMetrics,
  getDashboardConfig,
  getHealthLiteracy,
  getHealthMetrics,
  getHealthMetricsByPaginationLink2 as getHealthMetricsByPaginationLink,
  getHealthMetricsByPaginationLink as getHealthMetricsByPaginationLinkV3,
  getHealthMetrics3 as getHealthMetricsV2,
  getHealthMetrics2 as getHealthMetricsV3,
  getHealthSources,
  healthMetricsV1Path,
  healthMetricsV2Path,
  healthMetricsV3Path,
  healthSourcesV1Path,
  patchDashboardConfig,
  supportedMetrics,
  updateHealthMetrics
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/dashboard-api'] = window.leagueSDKsPresent['@leagueplatform/dashboard-api'] || [];
    window.leagueSDKsPresent['@leagueplatform/dashboard-api'].push('2.27.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/dashboard-api'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/dashboard-api module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map